const settings = {
    appName: process.env.VUE_APP_NAME,
    endPoint: process.env.VUE_APP_ENPOINT_BACKEND,
    endPointCt: process.env.VUE_APP_ENPOINT_BACKEND_CT,
    endPointFP: process.env.VUE_APP_ENPOINT_BACKEND_FP,
    endPointGT: process.env.VUE_APP_ENPOINT_BACKEND_GT,
    endPointApp: process.env.VUE_APP_ENPOINT_APP,
    appType: process.env.VUE_APP_ENV,
  }

export default settings;